var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconChevronRight = function SvgIconChevronRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.52 7.52055C10.6138 7.61423 10.6666 7.74132 10.6667 7.87389V8.12722C10.6652 8.2595 10.6126 8.38607 10.52 8.48055L7.09336 11.9006C7.03077 11.9637 6.94557 11.9992 6.8567 11.9992C6.76782 11.9992 6.68262 11.9637 6.62003 11.9006L6.1467 11.4272C6.08399 11.3658 6.04865 11.2817 6.04865 11.1939C6.04865 11.1061 6.08399 11.022 6.1467 10.9606L9.11336 8.00055L6.1467 5.04055C6.08359 4.97796 6.0481 4.89277 6.0481 4.80389C6.0481 4.71501 6.08359 4.62981 6.1467 4.56722L6.62003 4.10055C6.68262 4.03745 6.76782 4.00195 6.8567 4.00195C6.94557 4.00195 7.03077 4.03745 7.09336 4.10055L10.52 7.52055Z",
    fill: "#A9ADBB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconChevronRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconChevronRight.faa29e95.svg";
export { ForwardRef as ReactComponent };